import React from 'react';
import { useSelector } from 'react-redux';
import { Pencil, RotateCcw, Trash2 } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/Button';
import { DetailRow } from '@/components/ui/DetailSection';
import Bar from '@/components/elements/Bar';
import { Consultant } from '../hooks/useConsultant';

type ConsultantDetailProps = {
  data: Consultant;
  manufacturerName?: string;
  onEdit: () => void;
  onToggleActive: () => void;
};

const ConsultantDetail = ({
  data,
  manufacturerName,
  onEdit,
  onToggleActive,
}: ConsultantDetailProps) => {
  const permission = useSelector((state: any) => state.auth.pagePermission);

  return (
    <div className="flex-1 min-w-0 overflow-y-auto">
      <Bar
        text={`${data.first_name} ${data.last_name}`}
        content={
          permission === 2
            ? [
                <Button
                  key="toggle"
                  variant="ghost"
                  size="icon-sm"
                  onClick={onToggleActive}
                  data-testid="consultant-detail-toggle-active-btn"
                >
                  {data.is_active ? <Trash2 /> : <RotateCcw />}
                </Button>,
                <Button
                  key="edit"
                  variant="ghost"
                  size="icon-sm"
                  onClick={onEdit}
                  data-testid="consultant-detail-edit-btn"
                >
                  <Pencil />
                </Button>,
              ]
            : undefined
        }
      />
      <div className="p-6 space-y-3">
        <DetailRow label="Jméno" value={data.first_name} />
        <DetailRow label="Příjmení" value={data.last_name} />
        <DetailRow label="Výrobce" value={manufacturerName || '—'} />
        <DetailRow
          label="E-mail"
          value={
            data.email ? (
              <a
                href={`mailto:${data.email}`}
                className="text-primary-600 hover:underline"
                data-testid="consultant-detail-email-link"
              >
                {data.email}
              </a>
            ) : (
              '—'
            )
          }
        />
        <DetailRow label="Telefon" value={data.phone || '—'} />
        <DetailRow label="Poznámka" value={data.note || '—'} />
        <DetailRow
          label="Stav"
          value={
            <Badge variant={data.is_active ? 'success' : 'default'} size="sm">
              {data.is_active ? 'Aktivní' : 'Neaktivní'}
            </Badge>
          }
        />
      </div>
    </div>
  );
};

export default ConsultantDetail;
